import { RichTextField } from '@prismicio/client';
import { toArray } from 'lodash';

export default (contentField: RichTextField) => {
    const contentArray = toArray(contentField);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const contentGroups = contentArray.reduce((acc: any, value) => {
        // compare the current value with the last item in the collected array
        if (acc.length && acc[acc.length - 1][0].type == value.type) {
            // append the current value to it if it is matching
            acc[acc.length - 1].push(value);
        } else {
            // append the new value at the end of the collected array
            acc.push([value]);
        }
        return toArray(acc);
    }, []);

    return contentGroups;
};
